import Vue from 'vue'
import App from './App.vue';
import { elementui } from './elementUI/index';
import './elementUI/elementui-variable.scss';

Vue.config.productionTip = false;
elementui();

new Vue({
  render: h => h(App),
}).$mount('#app')
